/* eslint-disable react/display-name */
import React from 'react'

const SearchContext = React.createContext()

/**
 * A data provider that is wrapper around 
 * entire layouts to provide a search context
 */
const SearchProvider = ({ 
  engine, 
  children 
}) => (
  <SearchContext.Provider value={ engine }>
    {children}
  </SearchContext.Provider>
)

export default SearchContext
export { SearchProvider }